import { render, staticRenderFns } from "./SocialConnect.vue?vue&type=template&id=5621d79e&"
import script from "./SocialConnect.vue?vue&type=script&lang=js&"
export * from "./SocialConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports